var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"mx-auto",class:_vm.customClasses,attrs:{"loading":_vm.loading,"type":"image","height":"100%","max-height":_vm.maxHeight,"width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }